function callNoteApi(url, objWS, isPeerNotes, dimension) { 
    objWS.Call({
        url: url,
        async: true,
        success: function (msg) {
            if (msg.status == 'error') {
                console.error(msg);
                //Initializing this to prevent breaking of expansion.
                notes[dimension] = {};
                if(dimension ===NOTES_API_DIMENSIONS[0])
                    clearInterval(periodLevelInterval);
                return;
            }
            if (isPeerNotes) {
                bindPeerNotes(msg, msg.ticker)
            } else {
                notes[dimension] = jQuery.extend(true, {}, msg);
                notes[dimension].automationNotes = {};
                notes[dimension].disabledDatapointNoteid = [];
                addNotes(msg, dimension);
            }
        },
        error: function (msg) {
            console.error(msg.responseText);
            clearInterval(periodLevelInterval);
        }
    });
}

function addNotes(msg, dimension) {
    switch (dimension) {
        case NOTES_API_DIMENSIONS[1]:
            addParameterLevelNotes(msg);
            break;
        case NOTES_API_DIMENSIONS[0]:
            addPeriodLevelNote(msg);
            break;
    }
}

function attachParameterNotes(noteText, rowCell, rowName, internalNote) {//todo note change
    if (noteText) {
        if (rowName.length > 36) {
            noteText= noteText + rowName;
        }
        var popoverobj = {
            content:  '<span class="notes-text">'+noteText+'</span>',
            width: 350,
            style: "periodNotes",
            placement: "auto",
            "closeable": false,
            cache: false,
            arrow: true,
            trigger: 'hover'
    
        };
        rowCell.webuiPopover(popoverobj);
        addNotesClass(rowCell, internalNote)
    }
}

function addParameterNotesText(parameterLevelNote, noteIdTextDict, rowCell, rowName) {
    if (parameterLevelNote) {
        var noteText = '';
        var internalNote = false;

        $.each(parameterLevelNote, function (index, value) {
            var visibility = value.visibility;
            var source = value.sources;
            var notesMsg = noteIdTextDict[value.note_id];
            var noteValue = '<U>' + source + '</U> : ' + notesMsg;
            var el = {'revision': 'current'};
            var shouldShowNote = getShowNoteFlag(el,value);

            if (MEData.showInternalNote == 'true' && visibility == 'internal' && !internalNote) {
                internalNote = true;
            }

            if (visibility != 'internal' || MEData.showInternalNote == 'true') {
                if (shouldShowNote) {
                    noteText += noteValue.split('\n').join('<br>') + '<br>';
                }
            }
        });

        attachParameterNotes(noteText, rowCell, rowName, internalNote);
    }
}

function addNotesClass(ele, internalNote) {
    if (internalNote) {
        ele.addClass('internal_note');
    } else {
        ele.addClass('external_note');
    }
    ele.addClass('note-set')
}

function addParameterLevelNotes(msg) {
    if(msg === undefined || (msg && $.isEmptyObject(msg.parameter_level_dict))){
        return;
    }

    var dataGridTable = $('#tt');
    var dataGridPanel = dataGridTable.datagrid("getPanel");
    var dataGridPanelTable = dataGridPanel.find('table');
    var panel = dataGridPanelTable.eq(1);
    var dataRows = dataGridTable.datagrid("getRows");

    $.each(dataRows, function (indexRowData, valueRowData) {
        var rowCell = panel.find('tr[datagrid-row-index=' + indexRowData + ']').find('td').eq($.inArray("lineitem", rowDimension));
        var rowName = valueRowData.shortname;
        var parameterLevelNote;

        if (cut == 'NMV') {
            parameterLevelNote = msg.parameter_level_dict[valueRowData.parameterid];
            addParameterNotesText(parameterLevelNote, msg.note_id_and_text_dict, rowCell, rowName);

        } else if (cut == 'CPT' || cut == 'SAR') {
            var rowId = '';

            $.each(Object.keys(msg.parameter_level_dict), function (ind, val) {
                var valArray = val.split('_');

                if (valArray[valArray.length - 1] == valueRowData.id.split('-')[0]) {
                    rowId = val;
                    return;
                }
            });

            if (rowId) {
                parameterLevelNote = msg.parameter_level_dict[rowId];
                addParameterNotesText(parameterLevelNote, msg.note_id_and_text_dict, rowCell, rowName);
            }

        } else if (cut == 'SCH') {
            var schParamId = valueRowData.id;

            if (schParamId.indexOf('-') != -1) {
                schParamId = schParamId.split('-')[0];  // for splitting consensus in id
            }

            parameterLevelNote = msg.parameter_level_dict[schParamId];
            addParameterNotesText(parameterLevelNote, msg.note_id_and_text_dict, rowCell, rowName);
        }
    });
}

function getSourceSelectorPeriod(el) {
    var selector = '';
    var colPeriod = '';
    var colSource = '';

    $.each(colDimension, function (index, value) {
        if (value == 'period') {
            colPeriod = el.toLowerCase();
            selector += el;
        } else if (value == 'source') {
            colSource = window.gSource.toLowerCase();
            selector += colSource;
        } else if (value == 'revision') {
            selector += window.gRevision;
        }
    });

    if (!colSource) {
        colSource = 'CPT' == cut ? gScenario.toLowerCase() : window.gSource.toLowerCase();
    }

    return {
        'selector': selector,
        'colPeriod': colPeriod,
        'colSource': colSource
    }
}
var periodLevelInterval
function addPeriodLevelNote(msg, periodList){
    if(msg)
        notes['period'] = msg;
    else{
        if(notes['period'] == void 0){
            periodLevelInterval = setInterval(function () {
                addPeriodLevelNote()
            }, 100);
            return
        }
        msg = notes['period'];
    }
    clearInterval(periodLevelInterval);
    var periodLevelNotes = msg.period_level_dict;
    var table = $('.datagrid-header-inner').eq(1);
    var hasRev = colDimension.includes('revision');
    for (var key in periodLevelNotes) {
        if (periodLevelNotes.hasOwnProperty(key)) {
            var period = key.split('_')[1];
            var source = key.split('_')[0];
            var element = periodLevelNotes[key];
            var selector = hasRev ? period+ window.gRevision + source : period + source;
            var ele = table.find("td[field='" + selector.toLowerCase() + "']");
            if (ele.length) {
                var noteText = '';
                var internalNote = false;
    
                $.each(element, function (index, value) {
                    var visibility = value.visibility;
                    var noteValue = msg.note_id_and_text_dict[value.note_id];
    
                    if (MEData.showInternalNote == 'true' && visibility == 'internal' && !internalNote) {
                        internalNote = true;
                    }
    
                    if (visibility != 'internal' || MEData.showInternalNote == 'true') {
                        var el = {'revision': 'current', 'revision_datetime': current_date()};
                        var shouldShowNote = getShowNoteFlag(el,value);
    
                        if (shouldShowNote && noteValue) {
                            noteText += noteValue.split('\n').join('<br>') + '<notebr>';
                        }
                    }
                });
    
                if (noteText) {
                    var noteStr = "";
    
                    if (ele.attr('note')) {
                        noteStr = ele.attr('note').split('<br/>')[0] + "<br/>";
                    }
                    if (ele.attr('qttitle')) {
                        var titleStr = ele.attr('qttitle');
                        ele.removeAttr('qttitle');
                        ele.attr('note', noteStr + noteText + titleStr);
                    } else {
                        ele.attr('note', noteStr + noteText);
                    }
    
                    //Sar view period level notes binding
                    if (sourceLevelData[ele.attr('field')]) {
                        dataToBind = jQuery.extend(true, {}, sourceLevelData[ele.attr('field')]);
                    }
    
                    //todo test this later
                    // if (dataToBind.noteText && dataToBind.noteText != '') {
                    //     dataToBind.noteText += '<notebr>' + noteText;
                    // } else {
                    //     dataToBind.noteText = noteText;
                    // }
                    dataToBind.noteText = noteText;
    
                    bindPopoverForNotes(dataToBind, ele, '', 'sourceNotes');
    
                    addNotesClass(ele, internalNote);
                }
            }
        }
    }
}

//This function return true or false depending on whether to show the notes for the revision or not
function getShowNoteFlag(revision, value) {
    var effStart = '';
    var effEnd = '';
    var shouldShowNote = false;

    try {
        effStart = value.effective_start;
        effEnd = value.effective_end;
    }
    catch (err) {
        return shouldShowNote;
    }
    if (cut == 'NMV' || cut == 'SAR' || cut == 'SCH') {
        if (revision && revision.revision && revision.revision.toLowerCase() == 'current') {
            revision.revision_datetime = current_date()
        }
        if (revision && revision.revision_datetime) {
            var effStartInMilliSec = get_parsed_date(effStart);
            var revDateInMilliSec = get_parsed_date(revision.revision_datetime);
            var effEndInMilliSec = get_parsed_date(effEnd);
            if (effStartInMilliSec <= revDateInMilliSec && revDateInMilliSec <= effEndInMilliSec) {
                shouldShowNote = true;
            }
        }
    }
    
    return shouldShowNote;
}

function createPopoverForNotes(noteIDs, elem, source) {
    var template;
    var tooltipObj = [];
    var tooltipHtml = '';
    var noteIdLen = noteIDs.length;
    var notesKey = elem.attr('notesKey');
    var period = notesKey.split('_')[1];
    if(elem.hasClass('isPeerNote')){
        var ticker = elem.attr('ticker');
        var notesSectionalData =note_dict_peer[ticker].datapointPeriod[0];
    } else {
        var notesSectionalData = notes.datapointPeriod.filter(function(value){
            return value.periods.includes(period.toLowerCase())
        })[0];
    }
    // Get all the datapoint notes;
    // notes['datapoint'] is hard coded as till date this function is called only for data point level notes
  
    
    for (var eachNoteIdInd = 0; eachNoteIdInd < noteIdLen; eachNoteIdInd++) {
        template = notesSectionalData.automationNotesId[noteIDs[eachNoteIdInd]];
        var tooltipData = {
            "elem": elem,
            "isAutomatedNote": false,
            "data": {}
        };

        if (template && !notesSectionalData.automationNotes[noteIDs[eachNoteIdInd]]) {
            var periodsPanel = MEData.panels.filter(function (value) {
                return value.name == "periods"
            })[0];
            var currentQuarter = periodsPanel.currentquarter;
            var tempUrl = window.apiUrl+'/api/getAutomationnote?&companyid=' + MEData.companyid + '&templateid=' +
                template + '&dapparameterid=' + $(elem).attr('dapparam_id') + '&period=' + period + '&source=' + source +
                '&current_quarter=' + currentQuarter + '&depth==default' + '&half_year=' + MEData["half_year"];
            

            var ruleSymbolObj = {
                '1': {
                    rule: '1Q + 2Q + 3Q + 4Q = FY',
                    symbolsList: ["+", "+", "+", "&ne;"]
                },
                '2': {
                    rule: '4Q = FY',
                    symbolsList: ["&ne;"]
                },
                '3': {
                    rule: '1H + 2H = FY',
                    symbolsList: ["+", "&ne;"]
                },
                '4': {
                    rule: '2H = FY',
                    symbolsList: ["&ne;"]
                }
            };
            $.ajax({
                type: "GET",
                async: false,
                url: tempUrl,
                contentType: "application/json; charset=utf-8",
                dataType: 'json',
                success: function (msg) {
                    var data = {
                        "rule": ruleSymbolObj['' + template].rule,
                        "symbolsList": ruleSymbolObj['' + template].symbolsList,
                        "notesValue": msg.notesValue || [],
                        "lineItem": msg.lineItem,
                        "tabName": $('.fstdclick').text(),
                        "notesHeader": notesSectionalData.noteIdText[noteIDs[eachNoteIdInd]],
                        "calculatedValue": msg.calculatedValue,
                        "difference": msg.difference,
                        "difference_percentage": msg.difference_percentage,
                        "flowname": msg.flowname,
                        "optionHeader": notesSectionalData.automation_note_id_header_dict[noteIDs[eachNoteIdInd]] || ''
                    };

                    notesSectionalData.automationNotes[noteIDs[i]] = jQuery.extend(true, {}, data);

                    tooltipData.isAutomatedNote = true;
                    tooltipData.data = jQuery.extend(true, {}, data);
                    tooltipObj.push(tooltipData);

                    if (noteIdLen == 1) {
                        tooltipHtml = createHtmlForNotes(data);
                    }
                }
            });

        } else if (template && notesSectionalData.automationNotes[noteIDs[eachNoteIdInd]]) {
            tooltipData.isAutomatedNote = true;
            tooltipData.data = jQuery.extend(true, {}, notesSectionalData.automationNotes[noteIDs[eachNoteIdInd]]);
            tooltipObj.push(tooltipData);

            if (noteIdLen == 1) {
                tooltipHtml = createHtmlForNotes(notesSectionalData.automationNotes[noteIDs[eachNoteIdInd]]);
            }
        } else {
            tooltipData.isAutomatedNote = false;
            tooltipData.data = notesSectionalData.noteIdText[noteIDs[eachNoteIdInd]];
            tooltipObj.push(tooltipData);

            data = '<span class="manual-note">' + notesSectionalData.noteIdText[noteIDs[eachNoteIdInd]] + '</span>';

            //handle for text
            if (noteIdLen == 1) {
                tooltipHtml = data;
            }
        }

    }

    if (noteIdLen > 1 && tooltipObj.length === noteIdLen) {
        tooltipHtml = createPopoverForMultipleNotes(tooltipObj);
    }

    if (elem.attr('surprisetitle')) {
        data = '<span class="manual-note">' + elem.attr('surprisetitle') + '</span>';
        tooltipHtml = data + "<br><br>" + tooltipHtml;
    }

    return tooltipHtml;
}

function createPopoverForMultipleNotes(tooltipObj) {
    var text = '';
    for (var i = 0; i < tooltipObj.length; i++) {
        if (tooltipObj[i].isAutomatedNote) {
            text += createHtmlForNotes(tooltipObj[i].data);
        } else {
            text += '<span class="manual-note">' + tooltipObj[i].data + '</span>';
        }
        if (i != tooltipObj.length - 1) {
            text += '<div class="notes-divider"></div><br>';
        }

    }
    return text;
}
function redirectToRoute(url){
    if(WebuiPopovers) {
        WebuiPopovers.hideAll();
    }
    const routeChangedFromLib = new CustomEvent('routeChangedFromLib', {detail:{ url:url } })
    window.dispatchEvent(routeChangedFromLib); 
 
    
}

function createPopoverForSourceLevelNotes(element) {
    var dataToBind = sourceLevelData[element.attr('field')];
    var analystName = dataToBind.analyst;
    var analystId = dataToBind.analystid;
    var analystEmail = dataToBind.analystemail;
    var brokerName = dataToBind.broker;
    var modelDate = dataToBind.modeldate;
    var fiscalYear = dataToBind.fiscalyear;
    var noteText = dataToBind.noteText;
    var linkPg = dataToBind.pg;
    var linkCut = 'SAR';
    var linkTicker = dataToBind.ticker;
    var linkSource = dataToBind.source;
    var consensusText = dataToBind.consensusText;
    var popoverTemplate = '';
    var pvt_broker = showConPlusIcon(brokerName);

    function multipleNoteTemplate(text) {
        var notes = text.split('<notebr>');
        var noteLen = notes.length;
        var finalNoteSection = '';

        for (var i = 0; i < noteLen; i++) {
            if (notes[i].length != 0) {
                //Doing the -2 bit in the (notes.length - 2) operation, since (-1) gives me the  actual indices and (-2) will exculde the empty array item after delimiting the <br>
                finalNoteSection = finalNoteSection + notes[i] + (noteLen != 1 && i != (noteLen - 2) ? '<hr style="width:100%;">' : '');
            }
        }
        return finalNoteSection;
    }

    if (linkSource.toLowerCase() == 'va actuals' && noteText) {
        popoverTemplate = '<span class="notes-text-header">Notes for ' + fiscalYear + '</span><br/>'
            + '<span style="font-size:12px;font-weight:400;color:#000000;">' + multipleNoteTemplate(noteText) + '</span>';
        return popoverTemplate;
    }
    if (linkSource.toLowerCase() === 'consensus' || linkSource.toLowerCase() === 'custom' || linkSource.toLowerCase() === "consensus+") {
        if (modelDate) {
            popoverTemplate = popoverTemplate + '<span class="notes-text-header">Updated: </span><span class="notes-text">' + modelDate + '</span><br/>';
        }
        //for consensus+ tooltip
        if(consensusText=="" && linkSource === 'Consensus+' && (dataToBind.cut == "NMV" || dataToBind.cut == "SCH")){
            popoverTemplate = popoverTemplate + "<span class='notes-text'><b>" + linkSource.slice(0, -1) + "</b> <span style='color: #f2883d;vertical-align: middle;' class='fa fa-plus'></span> includes additional brokers not available in Visible Alpha’s standard consensus</span><br/>"
        }

        popoverTemplate = popoverTemplate + '<span class="notes-text">' + consensusText + '</span>';

    } else {
        var brokerLink = '/reporting/broker/'+brokerName;
        var mexLink = '/mex/'+ linkTicker +'/'+linkCut+'/' + encodeURIComponent(linkPg) + '/'+linkSource;
        
        if (analystId) {
            var analystLink = '/reporting/analyst/'+analystId;
            if ($.inArray(linkSource.toLowerCase(), MEData.give_to_get_src) == -1) {
                popoverTemplate = '<a onclick=redirectToRoute("'+analystLink+'")>' + analystName + '</a><br/>'
                    + '<a style="font-size:12px;font-weight:400;color:#3274A9;" onclick=redirectToRoute("'+brokerLink+'")>' + dataToBind.sourcefullname + ' Home</a><br/>'
                    + '<a style="font-size:12px;font-weight:400;color:#3274A9;" href="mailto:' + analystEmail.trim().toLowerCase() + '">' + analystEmail.trim().toLowerCase() + '</a><br/>'
                    + '<a style="font-size:12px;font-weight:400;color:#3274A9;" onclick=redirectToRoute("'+ mexLink + '")>' + 'Go to Analyst Model' + '</a><br/>'
                    + '<br/>'
                    + '<span class="notes-text-header">Model Received </span><span class="notes-text">' + modelDate + '</span>';
            } else {
                popoverTemplate = '<span class="notes-text">' + analystName + '</span><br/>'
                    + '<a style="font-size:12px;font-weight:400;color:#3274A9;" href="mailto:' + analystEmail.trim().toLowerCase() + '">' + analystEmail.trim().toLowerCase() + '</a><br/>'
                    + '<br/>'
                    + '<span class="notes-text-header">Model Received </span><span class="notes-text">' + modelDate + '</span>';

            }
            popoverTemplate = showSourceLevelCPlusIconForNotes(dataToBind.cut,pvt_broker, popoverTemplate);
        } else {
            if (linkSource.toLowerCase() !== 'filings' && $.inArray(linkSource.toLowerCase(), MEData.give_to_get_src) == -1) {
                popoverTemplate = '<a style="font-size:12px;font-weight:400;color:#3274A9;" onclick=redirectToRoute("'+brokerLink+'")>' + dataToBind.sourcefullname + '</a><br/>'
                    + '<a style="font-size:12px;font-weight:400;color:#3274A9;" onclick=redirectToRoute("'+ mexLink+'")>' + 'Go to Analyst Model' + '</a><br/>'
                    + '<br/>'
                    + '<span class="notes-text-header">Model Received </span><span class="notes-text">' + modelDate + '</span>';


                popoverTemplate = showSourceLevelCPlusIconForNotes(dataToBind.cut,pvt_broker, popoverTemplate);

            } else if ($.inArray(linkSource.toLowerCase(), MEData.give_to_get_src) != -1) {
                popoverTemplate = '<span class="notes-text-header">Model Received </span><span class="notes-text">' + modelDate + '</span>';
            } else if (modelDate) {
                popoverTemplate = '<span class="notes-text-header">Date: </span><span class="notes-text">' + modelDate + '</span>';
            }
        }
    }

    if (noteText) {
        popoverTemplate = popoverTemplate + '<br/><br/>'
            + '<span class="notes-text-header">Notes for ' + fiscalYear + '</span><br/>'
            + '<span class="notes-text">' + multipleNoteTemplate(noteText) + '</span>';
    }

    return popoverTemplate;
}

function showSourceLevelCPlusIconForNotes(cut,pvt_broker,popoverTemplate){
    if((cut !== 'SAR') && pvt_broker) {
        popoverTemplate = popoverTemplate + "<br/><br/>" +
            "<img class='conPlus_icon' src='" + window.assetUrl + "/consensus_plus_icon.png'/>" +
            " <span class='notes-text'>This broker is part of <b>Consensus</b> <span style='color: #f2883d;vertical-align: middle;' class='fa fa-plus'></span>and is not available in Visible Alpha's standard consensus</span><br/>";
    }
    return popoverTemplate;
}

function bindPopoverForNotes(ids, elem, source, forType, hasAutomated) {
    $(elem).webuiPopover('destroy');
    if (ids.source && ids.source.toLowerCase() === 'va actuals' && ids.noteText == '') {
        return
    }

    var popoverobj = {
        content: function () {
            if (forType != 'sourceNotes') {
                return createPopoverForNotes(ids, elem, source);
            }
            else {
                return createPopoverForSourceLevelNotes(elem);
            }
        },
        width: 250,
        style: "notes",
        placement: "auto",
        "closeable": false,
        cache: false,
        arrow: true,
        trigger: 'hover',
        onShow: function($element){ clickToAddEvent($element)}

    };
    if (forType == 'sourceNotes') {
        //blank tooltip should not be binded.Hence return
        if (ids.source == "Consensus" && ids.modeldate == '' && ids.noteText == '' && ids.consensusText == '') {
            return;
        }
        popoverobj.style = "periodNotes";
        sourceLevelData[elem.attr('field')] = jQuery.extend(true, {}, ids);
    }  else if (forType == 'periodNotes') {
        popoverobj.content = function () {
            var html='';
            for (var i=0;i<ids.length;i++) {
                html += i==0 ? '<span class="notes-text-header">Date: </span>': '<br/><span class="notes-text-header">Model date: </span>';
                html += '<span class="notes-text">' + ids[i] + '</span>';
            }
            return html;
        };
        popoverobj.cache = true;
        popoverobj.style = "periodNotes";
    } else {// datapoint level note
        if (hasAutomated) {
            popoverobj.width = 450;
            popoverobj.closeable = true;

        }
        // used in inspector for datapoint
        $(elem).attr('validNoteIds', ids);
    }

    $(elem).webuiPopover(popoverobj);
}

function createHtmlForNotes(data) {
    var htmlString = '';
    var valueTable = '<table class="notes-table"><tr>';
    var firstRow = '', secondRow = '', i = 0;

    firstRow += '<th>&nbsp;</th>';
    secondRow += '<td>' + data.lineItem + '</td>';
    for (var i = 0; i < data.notesValue.length; i++) {
        var key = Object.keys(data.notesValue[i]);
        var value = data.notesValue[i][key[0]];
        if (i < data.symbolsList.length) {
            firstRow += '<th class="value">' + key[0] + '</th><th class="symbol">&nbsp;</th>';
            if (parseFloat(value, 10) < 0) {
                secondRow += '<td class="value make-me-red">(' + Math.abs(value) + ')</td>';
            } else {
                secondRow += '<td class="value">' + value + '</td>';
            }

            secondRow += '<td>' + data.symbolsList[i] + '</td>';

        } else {
            firstRow += '<th class="value">' + key[0] + '</th>';
            if (parseFloat(value, 10) < 0) {
                secondRow += '<td class="value make-me-red last-value">(' + Math.abs(value) + ')</td>';
            } else {
                secondRow += '<td class="value last-value">' + value + '</td>';
            }
        }
    }
    valueTable = valueTable + firstRow + '</tr><tr>' + secondRow + '</tr></table>';
    var calculatedValueDiv = '';
    if (parseFloat(data.calculatedValue, 10) < 0) {
        calculatedValueDiv += '<span class="calc-value make-me-red">(' + Math.abs(data.calculatedValue) + ')</span>';
    } else {
        calculatedValueDiv += '<span class="calc-value">' + data.calculatedValue + '</span>';
    }
    var diffValue = '';
    if (parseFloat(data.difference, 10) < 0) {
        diffValue += '<span class="make-me-red">(' + Math.abs(data.difference) + ')</span>';
    } else {
        diffValue += '<span>' + data.difference + '</span>';
    }
    var diffPercent = '';
    if (parseFloat(data.difference_percentage, 10) < 0) {
        diffPercent += '<span class="make-me-red">{(' + Math.abs(data.difference_percentage) + '%)}</span>';
    } else {
        diffPercent += '<span>{' + data.difference_percentage + '%}</span>';
    }
    htmlString = '<div class="notes-holder">' +
        '<div class="notes-header-holder"><span class="notes-header">' + data.notesHeader + '</span></div>' +
        '<div class="tab-name-holder section-notes"><span class="tab-name">' + data.tabName + '</span></div>' +
        '<div class="notes-options-holder section-notes">' +
        '<div class="logic-holder"><span class="icon fa fa-tag selected"></span><span class="text">' + data.optionHeader + '</span></div>' +
        '<div class="excluded-holder" style="display:none"><span class="icon fa fa-tag"></span><span class="text">Excluded from Consensus</span></div>' +
        '</div>' +
        '<div class="rule-holder section-notes">' +
        '<span class="rule-header">Rule </span>' +
        '<span class="rule">' + data.rule + '</span>' +
        '<div class="flow-holder"><span class="icon fa fa-tag"></span><span class="text">' + data.flowname + '</span></div>' +
        '</div>' +
        '<div class="notes-values-holder section-notes">' +
        '<div class="notes-table-holder">' + valueTable + '</div>' +
        '<div class="calc-value-holder">' +
        '<span>Expected Calculated Value: </span>' + calculatedValueDiv +
        '</div>' +
        '<div class="diff-value-holder">' +
        '<span>Difference: </span><span class="diff-value">' + diffValue + diffPercent + '</span>' +
        '</div>' +
        '</div></div>';

    return htmlString
}

function bindPeerNotes(resp, ticker){
    note_dict_peer[ticker] = {
        datapointPeriod:[]
    };
    var currentTickerNotes = note_dict_peer[ticker];
    var notesObj = {
        noteIdText: resp.note_id_and_text_dict,
        noteData : resp.datapoint_level_dict,
        automationNotesId : resp.note_id_and_template_id_dict,
        automation_note_id_header_dict: resp.automation_note_id_header_dict,
    }
    currentTickerNotes['datapointPeriod'].push( notesObj);
    var peersTable = $('.datagrid-ftable').eq(1);
    // iterate over datapoint notes response only
    for (var key in resp.datapoint_level_dict) {
        if (resp.datapoint_level_dict.hasOwnProperty(key)) {
            var point =key.split('_');
            var selector = '';
            if(!period_fiscal_dict[point[1]]){
                continue
            }
            selector += period_fiscal_dict[point[1].toLowerCase()];
            if (point[0].toLowerCase() == 'filings')
                selector += 'consensus';
            else
                selector += point[0].toLowerCase();
            
            var tdEle = peersTable.find('td[field='+selector+'][ticker='+ticker+']');
            if(tdEle.length > 0){
                var data = {
                    parameterid: point[2],
                    period:point[1],
                    source: point[0],
                    revision:{
                        revision: 'current',
                        revision_date: new Date()
                    },
                    el: tdEle
                }
                tdEle.addClass('isPeerNote');
                bindNotesToCell(notesObj,key, data)
            }
        }
    }
    
}

function getPeriodWiseDataPointNotes(periodList){
    if(!notes['datapointPeriod']){
        notes['datapointPeriod'] =[];
        notes['allPeriods'] = [];
    }
    var currentPeriods = periodList.filter(function(val){
        val = val.toLowerCase();
        if(!notes.allPeriods.includes(val))
            return val
    });
    if(currentPeriods.length == 0){
        return;
    }
    var url = window.apiUrl+ "/api/getAllNotes?&ticker="+MEData.ticker+"&cut="+cut+"&tab="+pg+"&dimension=datapoint&period=";
    url += currentPeriods.join('&period=');
    $.ajax({
        type: "GET",
        async: true,
        url: url,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        success: function (resp) {
            var per = currentPeriods.map(function(val){return val.toLowerCase()})
            notes.allPeriods = notes.allPeriods.concat(per);
            notes['datapointPeriod'].push( {
                periods: per,
                noteIdText: resp.note_id_and_text_dict,
                noteData : resp.datapoint_level_dict,
                automationNotesId : resp.note_id_and_template_id_dict,
                automation_note_id_header_dict: resp.automation_note_id_header_dict,
            });
            // filter to check if any period notes binding pending
            var pendingBinding = pendingDataPointNote.periods.filter(function(value, index){
                if(per.includes(value.toLowerCase())){
                    return true
                }
            });
            if(pendingBinding.length > 0){
                // iterate over datapoint notes response only
                for (var key in resp.datapoint_level_dict) {
                    if (resp.datapoint_level_dict.hasOwnProperty(key)) {
                        var period = key.split('_')[1];
                        // check which binding is pending and then call for bindDataPointNote
                        if(pendingDataPointNote.data[period] && pendingDataPointNote.data[period][key]){
                            bindDataPointNote(pendingDataPointNote.data[period][key]);
                        }
                    }
                }
                // remove period object for data object and periods array since calls done
                pendingDataPointNote.periods = pendingDataPointNote.periods.filter(function(value, index){
                    if(!per.includes(value.toLowerCase())){
                        return true
                    } else {
                        delete pendingDataPointNote.data[value]
                    }
                });
            }
            
        },
        error:function(){
            var per = currentPeriods.map(function(val){return val.toLowerCase()})
            notes.allPeriods = notes.allPeriods.concat(per);
            notes['datapointPeriod'].push( {
                periods: per,
                noteIdText: {},
                noteData : {},
                automationNotesId :{},
                automation_note_id_header_dict: {},
            });
        }
    });
}
var pendingDataPointNote = {
    periods:[],
    data:{} // data structure as { 1qfy-2019 : { jefferies_fy-2020_11499088: dataPassed } }
};
function bindDataPointNote(data){
    if(data.source.toLowerCase() == 'va actuals'){
        //no notes present for va actuals
        return;
    }
    if(!notes['datapointPeriod']){
        notes['datapointPeriod'] =[];
        notes['allPeriods'] = [];
    }
    var notesSectionalData = notes.datapointPeriod.filter(function(value){
        return value.periods.includes(data.period.toLowerCase())
    })[0];
    var selector = data.source.toLowerCase()+'_'+ data.period.toLowerCase()+'_'+ data.parameterid;
    if(!notesSectionalData){
        //call for notes pending response
        //keep array and bind later

        if(!pendingDataPointNote.periods.includes(data.period.toLowerCase())){
            pendingDataPointNote.periods.push(data.period.toLowerCase());
            pendingDataPointNote.data[data.period.toLowerCase()] = {};
        }

        pendingDataPointNote.data[data.period.toLowerCase()][selector] = data;

        return;
    }
    if(notesSectionalData.noteData[selector]){
        bindNotesToCell(notesSectionalData,selector, data);
    }
}

function bindNotesToCell(notesSectionalData,selector, data){
    var validNoteId=[];
    var hasAutomated = false;
    var internalNote = false;
    for (var index = 0; index < notesSectionalData.noteData[selector].length; index++) {
        var val = notesSectionalData.noteData[selector][index];
        if(getShowNoteFlag(data.revision, val)){
            var visibility = val.visibility;

            if (MEData.showInternalNote == 'true' && visibility == 'internal' && !internalNote) {
                internalNote = true;
            }

            if (visibility != 'internal' || MEData.showInternalNote == 'true') {
                validNoteId.push(val.note_id)
            }
            var template = notesSectionalData.automationNotesId[val.note_id];

            if (template) {
                hasAutomated = true;
            }
        }
    };
    notesSectionalData.automationNotes = {};
    if(validNoteId.length){
        bindPopoverForNotes(validNoteId, data.el, data.source,'datapoint', hasAutomated);
        data.el.prop("title", '');
        data.el.attr('notesKey', selector);
        addNotesClass(data.el, internalNote);
    }
}